 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"stencil-polyfills-css-shim":"stencil-polyfills-css-shim","stencil-polyfills-dom":"stencil-polyfills-dom"}[chunkId]||chunkId) + "." + {"chunk-03b202f8":"519415ff","chunk-0e483cbd":"e32dcfb5","chunk-19bd66b2":"ccb9287b","chunk-2d0a3596":"23ba5b07","chunk-2d0a4478":"d68ed0a1","chunk-2d0a47e0":"2db9d7eb","chunk-2d0a4b20":"afdedc47","chunk-2d0b1f84":"f450f343","chunk-2d0b2d29":"57cdbc7a","chunk-2d0c4d85":"4f643a7b","chunk-0f506ebe":"24251db8","chunk-10719a58":"04251748","chunk-e72ff10a":"a97aa8df","chunk-ef2ff8ac":"f2e0f9eb","chunk-2d0c7ca9":"d851851f","chunk-38fe1b4c":"d1b22712","chunk-42a50942":"509cbf65","chunk-51ccde7c":"9b48b98c","chunk-c80ee128":"98d6464c","chunk-fca76dfa":"1a1b79f9","chunk-c15370b0":"25316d28","chunk-0cce0940":"db9b2866","chunk-2dc205d5":"2c7157d9","chunk-38557626":"a2cd02f0","chunk-388f6fdf":"a8495368","chunk-bd898cba":"f7e647de","chunk-e9f4a59e":"1850ba0c","chunk-2d0c53bb":"034c4861","chunk-2d0c85d9":"0a061509","chunk-2d0c90fc":"83ec0d31","chunk-2d0ce755":"883f3278","chunk-2d0d0219":"52ee0039","chunk-2d0e2742":"8f432728","chunk-2d0e5b74":"2304f2a9","chunk-2d0f0bc5":"50849b67","chunk-2d0f1574":"d9614faa","chunk-2d20847f":"71d1e556","chunk-2d209b43":"d6539ec3","chunk-2d210c47":"f2819e03","chunk-2d212b1d":"ab0543b3","chunk-2d221e01":"a9b23ad1","chunk-2d222737":"8a74d4f8","chunk-2d22fd16":"9be1c6a0","chunk-2d230115":"0f33e445","chunk-2d23028a":"5232a663","chunk-2f6fe07e":"c1c020b3","chunk-30d51d72":"59df8b3a","chunk-321fb378":"0ec51bd4","chunk-33ef095c":"9ba44a93","chunk-72c13e0c":"a042b4b1","chunk-7ca651b5":"df732318","chunk-e9200272":"ca415d39","chunk-eee7cf9e":"e645f6d0","chunk-fb54fa2e":"51ea7c2f","chunk-2d0cf2d6":"e61b2818","chunk-647f369e":"0ed73bf0","chunk-7fe6218e":"bb308d40","chunk-43eb7b7a":"e4bf316b","chunk-bf1cb0b0":"36b7a16d","chunk-fef1189a":"652bce62","chunk-2d0abc10":"9f6bd388","chunk-2d0ac931":"cc71baa3","chunk-2d0c211b":"20162011","chunk-2d0cf315":"e659bcff","chunk-2d217def":"9b86ebe8","chunk-2d21a9aa":"bdd6764c","chunk-2d222cca":"b8e77524","chunk-2d22895d":"060c8c65","chunk-2d23721e":"f4233577","stencil-polyfills-css-shim":"b85f8bdc","stencil-polyfills-dom":"6e9caa76"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-03b202f8":1,"chunk-0e483cbd":1,"chunk-19bd66b2":1,"chunk-0f506ebe":1,"chunk-10719a58":1,"chunk-e72ff10a":1,"chunk-ef2ff8ac":1,"chunk-38fe1b4c":1,"chunk-42a50942":1,"chunk-c80ee128":1,"chunk-c15370b0":1,"chunk-0cce0940":1,"chunk-2dc205d5":1,"chunk-38557626":1,"chunk-388f6fdf":1,"chunk-bd898cba":1,"chunk-e9f4a59e":1,"chunk-2f6fe07e":1,"chunk-30d51d72":1,"chunk-33ef095c":1,"chunk-72c13e0c":1,"chunk-7ca651b5":1,"chunk-e9200272":1,"chunk-eee7cf9e":1,"chunk-fb54fa2e":1,"chunk-647f369e":1,"chunk-7fe6218e":1,"chunk-43eb7b7a":1,"chunk-bf1cb0b0":1,"chunk-fef1189a":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"stencil-polyfills-css-shim":"stencil-polyfills-css-shim","stencil-polyfills-dom":"stencil-polyfills-dom"}[chunkId]||chunkId) + "." + {"chunk-03b202f8":"70ef055e","chunk-0e483cbd":"6d3847c9","chunk-19bd66b2":"ef519537","chunk-2d0a3596":"31d6cfe0","chunk-2d0a4478":"31d6cfe0","chunk-2d0a47e0":"31d6cfe0","chunk-2d0a4b20":"31d6cfe0","chunk-2d0b1f84":"31d6cfe0","chunk-2d0b2d29":"31d6cfe0","chunk-2d0c4d85":"31d6cfe0","chunk-0f506ebe":"013a209e","chunk-10719a58":"2896ec2e","chunk-e72ff10a":"d87376b8","chunk-ef2ff8ac":"13cebb6b","chunk-2d0c7ca9":"31d6cfe0","chunk-38fe1b4c":"013a209e","chunk-42a50942":"0a26f220","chunk-51ccde7c":"31d6cfe0","chunk-c80ee128":"41361c4e","chunk-fca76dfa":"31d6cfe0","chunk-c15370b0":"c6758e74","chunk-0cce0940":"98007bce","chunk-2dc205d5":"1c40be8a","chunk-38557626":"46c150a3","chunk-388f6fdf":"4faddb04","chunk-bd898cba":"8682220d","chunk-e9f4a59e":"6a8c3bb8","chunk-2d0c53bb":"31d6cfe0","chunk-2d0c85d9":"31d6cfe0","chunk-2d0c90fc":"31d6cfe0","chunk-2d0ce755":"31d6cfe0","chunk-2d0d0219":"31d6cfe0","chunk-2d0e2742":"31d6cfe0","chunk-2d0e5b74":"31d6cfe0","chunk-2d0f0bc5":"31d6cfe0","chunk-2d0f1574":"31d6cfe0","chunk-2d20847f":"31d6cfe0","chunk-2d209b43":"31d6cfe0","chunk-2d210c47":"31d6cfe0","chunk-2d212b1d":"31d6cfe0","chunk-2d221e01":"31d6cfe0","chunk-2d222737":"31d6cfe0","chunk-2d22fd16":"31d6cfe0","chunk-2d230115":"31d6cfe0","chunk-2d23028a":"31d6cfe0","chunk-2f6fe07e":"185af1b9","chunk-30d51d72":"a37a5979","chunk-321fb378":"31d6cfe0","chunk-33ef095c":"013a209e","chunk-72c13e0c":"774cf801","chunk-7ca651b5":"ef5f42db","chunk-e9200272":"02ec4705","chunk-eee7cf9e":"5a9b779d","chunk-fb54fa2e":"04f7f7ee","chunk-2d0cf2d6":"31d6cfe0","chunk-647f369e":"fed70f2c","chunk-7fe6218e":"9fccbb8b","chunk-43eb7b7a":"ed767b45","chunk-bf1cb0b0":"471397aa","chunk-fef1189a":"03c9bb7c","chunk-2d0abc10":"31d6cfe0","chunk-2d0ac931":"31d6cfe0","chunk-2d0c211b":"31d6cfe0","chunk-2d0cf315":"31d6cfe0","chunk-2d217def":"31d6cfe0","chunk-2d21a9aa":"31d6cfe0","chunk-2d222cca":"31d6cfe0","chunk-2d22895d":"31d6cfe0","chunk-2d23721e":"31d6cfe0","stencil-polyfills-css-shim":"31d6cfe0","stencil-polyfills-dom":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
